import { useAbility } from '@mdvip/shared/stores/authStore';
import { Navigate } from 'react-router-dom';

/* Patients is the landing page, but it is gated on Member read. Without that ability the gate sends
   the user back to `/`, so landing there anyway would loop; those users land on Resources instead. */
export function HomeRedirect() {
  const ability = useAbility();
  return <Navigate to={ability?.can('read', 'Member') ? '/patients' : '/resources'} replace />;
}
